export default __webpack_public_path__ + "static/media/gallery35.1f6ded46.jpg";